import React from "react";
import { RouteProps } from "react-router-dom";
import Button from "../../../components/Form/Button";
import { IGroup } from "../../../services/api/Group";
import Form from "../components/Form";
import ItemBox from "../../../components/ItemBox";

interface GroupListProps extends RouteProps {
    data: IGroup[];
    updateList?: Function;
}

const GroupList: React.FC<GroupListProps> = ({ data, updateList }) => {
  // function DisplayEdit(obj: HTMLFormElement) {
  // }

  function toggleForm(e: any) {
    e.target.parentNode.nextElementSibling.classList.toggle("form--open");
  }

  function renderRow(group: IGroup) {
    return (
      <li key={group.id}>
        <ItemBox
          {...(group.children ? { className: "hasChildren" } : null)}
          name={group.name}
        >
          <Button className="box__edit" title="Edit" onClick={toggleForm} />
        </ItemBox>
        <div className="groups__form--edit">
            <Form groups={data} group={group} updateList={updateList} />
        </div>
        {group.children ? (
          <ul className="groups__list"> {group.children.map(renderRow)}</ul>
        ) : null}
      </li>
    );
  }

  return (
    <React.Fragment>
      <ul className="groups__list groups__list--main">{data.map(renderRow)}</ul>
    </React.Fragment>
  );
};

export default GroupList;
